import { SessionKey } from '../constants/SessionKey'
import { AuthTokens } from '../models/AuthTokens'
import { Defaults } from '../constants/Defaults'
import { LOCAL_STORAGE } from './LocalStorage'
import { Session } from '../models/Session'
import { User } from '../models/User'

export function CurrentUser(): User {
  const sessionService = SessionService.getInstance()
  return sessionService.getCurrentUser()
}

export class SessionService {
  private static instance: SessionService

  static getInstance() {
    if (!this.instance) {
      this.instance = new this()
    }

    return this.instance
  }

  clearSession() {
    LOCAL_STORAGE.set(SessionKey.SESSION, this.createSignedOutSession())
    LOCAL_STORAGE.clear(SessionKey.PRIVATE_ROUTE_AUTH_CODE)
    LOCAL_STORAGE.clear(SessionKey.AZURE_SEARCH_API_KEY)
    LOCAL_STORAGE.clear(SessionKey.GOOGLE_MAPS_API_KEY)
    LOCAL_STORAGE.clear(SessionKey.SES_ROLE_EXT_ID)
    LOCAL_STORAGE.clear(SessionKey.IDENTITY_TOKEN)
    LOCAL_STORAGE.clear(SessionKey.PARSE_API_KEY)
  }

  getCurrentSession(): Session {
    let session = LOCAL_STORAGE.getOrDefault(SessionKey.SESSION, undefined) as Session
    if (!session) {
      session = this.createSignedOutSession()
    }

    return session
  }

  getCurrentUser(): User {
    const session = this.getCurrentSession()
    return session.user
  }

  setCurrentSession(session: Session) {
    LOCAL_STORAGE.set(SessionKey.SESSION, session)
  }

  setCurrentUser(signedIn: boolean, firstName: string, lastName: string, fullName: string, email: string): User {
    const session = this.getCurrentSession()

    session.user.signedIn = signedIn
    session.user.lastName = lastName
    session.user.firstName = firstName
    session.user.fullName = fullName
    session.user.email = email

    LOCAL_STORAGE.set(SessionKey.SESSION, session.user)

    return session.user
  }

  private createSignedOutSession() {
    return {
      user: {
        signedIn: false,
        lastName: Defaults.DEFAULT_LAST_NAME,
        firstName: Defaults.DEFAULT_FIRST_NAME,
        fullName: Defaults.DEFAULT_FULL_NAME,
        email: Defaults.DEFAULT_EMAIL,
      } as Defaults,
      tokens: {
        identityToken: '',
        refreshToken: '',
        accessToken: '',
      } as AuthTokens
    } as Session
  }
}

export default SessionService

export const SESSION_SERVICE = SessionService.getInstance()
